import {InputAdornment} from "@mui/material";
import {Search} from "@mui/icons-material";
import TextField from "@mui/material/TextField";
import {useTranslation} from "react-i18next";
import {ChangeEvent, FC} from "react";

interface Props {
    searchText: string
    handleChangeSearchText: (e: ChangeEvent<HTMLTextAreaElement>) => void
}

const SearchWishTextview: FC<Props> = (props) => {
    const {t} = useTranslation()

    return (
        <TextField fullWidth
                   label={t('search_wish')}
                   variant="outlined"
                   color="primary"
                   size='small'
                   sx={{maxWidth: {xs: '100%', sm: '320px'}}}
                   value={props.searchText}
                   onChange={props.handleChangeSearchText}
                   InputProps={{
                       endAdornment: <InputAdornment
                           position="end">
                           <Search color="primary"/>
                       </InputAdornment>
                   }}/>
    )
}
export default SearchWishTextview
